<template lang="pug">
v-dialog(v-if="showDialog" v-model="showDialog" max-width="560" persistent fluid scrollable)
  v-card(rounded="lg")
    v-card-title.px-4
      v-spacer
      h6.ml-10 {{ $t('add_new_assignees') }}
      v-spacer
      v-btn(icon @click="showDialog = false")
        v-icon mdi-close
    v-divider

    v-card-text.px-6.pt-6.pb-16
      .text-center(v-if="isLoading")
        v-progress-circular( width="2" size="50" color="primary" indeterminate)
      template(v-else)
        .p1 {{ $t('choose_new_assignee_for_task') }}:
        v-form(ref="form")
          yc-autocomplete.mt-4(:label="$t('choose_your_assigness')" :items="assignees" v-model="selectedAssignees" itemText="title" itemValue="id" :rules="rules.not_empty_array") 
    v-divider

    v-card-actions.py-4.px-6
      v-spacer
      v-btn.button-Aa-medium.px-4.primary400--text(@click="showDialog = false" text height=40) {{ $t('back') }}
      v-btn.button-Aa-medium.px-4(@click="save" :loading="isSaving" color="info" depressed height=40 :disabled="!selectedAssignees.length") {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['open', 'edited', 'task'],
  data: () => ({
    isLoading: true,
    isSaving: false,
    assignees: [],
    selectedAssignees: [],
    rules: {
      not_empty: [v => v.trim().length || 'This field is required'],
      not_empty_array: [v => !!(v && v.length) || 'This field is required']
    },
  }),
  computed: {
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    ...mapGetters({
      company: 'getCompany'
    })
  },
  created () {
    this.fetchAssignees()
    if (this.task.assign_to.length) {
      this.selectedAssignees = []
      this.task.assign_to.forEach(member => {
        this.selectedAssignees.push(member.id)
      })
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchAssignees () {
      this.$axios.get(`/members/?company=${this.company.id}&app=connect&page_size=-1`)
        .then(resp => {
          const results = resp.data.results
          this.assignees = results.map(item => {
            const member = item
            member.title = `${item.user.first_name} ${item.user.last_name}` 
            return member
          })
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    save () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isSaving = true
      this.$axios.patch(`/connect/${this.company.slug}/tasks/${this.task.id}`, { assign_to: this.selectedAssignees })
        .then(() => {
          this.isEditing = false
          this.showMessage(['success', this.$t('success_message.new_assignee_added_successfully')])
          this.$emit('edited')
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_add_new_assignee')])
        })
        .finally(() => {
          this.isSaving = false
        })
    }
  }
}
</script>